import dateTimeHelper from "../../Helpers/datetimeHelper";

export default class EventDivData {
  constructor(actEntry, calendarParameters, left) {
    this.xOfEventDiv = left;
    const endtimeInMinutes = dateTimeHelper.convertTimeToMinutes(actEntry.tempEndTime);
    const startTimeInMinutes = dateTimeHelper.convertTimeToMinutes(actEntry.tempStartTime);
    const visibleEndTimeInMinutes = dateTimeHelper.convertTimeToMinutes(calendarParameters.visibleEndTime);
    let eventDuration = endtimeInMinutes - startTimeInMinutes;

    if (eventDuration < 0) eventDuration += 24 * 60;

    if (startTimeInMinutes > endtimeInMinutes && startTimeInMinutes + eventDuration > visibleEndTimeInMinutes) {
      eventDuration = visibleEndTimeInMinutes - startTimeInMinutes;
      if (eventDuration < 0) eventDuration += 24 * 60;
    }

    this.heightOfEventDiv = (eventDuration * calendarParameters.heightOfDayTimeframesDiv) / calendarParameters.visibleStartToEnd;

    // let numberOfEventDays = (dateTimeHelper.getDateFromDateString(actEntry.tempEndDate) - dateTimeHelper.getDateFromDateString(actEntry.tempStartDate)) / (1000 * 60 * 60 * 24) + 1;
    let numberOfEventDays = 1;

    // If a multi-day entry ends at midnight, the display width should not include the last day (which means 0 minutes on that day in this case).
    if (numberOfEventDays > 2 && actEntry.tempEndTime === "00:00") {
      numberOfEventDays--;
    }

    this.widthOfEventDiv = calendarParameters.widthOfDayDiv * numberOfEventDays - calendarParameters.borderOfDayDiv;

    this.yOfEventDiv =
      calendarParameters.heightOfDayHeaderDiv +
      ((dateTimeHelper.convertTimeToMinutes(actEntry.tempStartTime) - dateTimeHelper.convertTimeToMinutes(calendarParameters.visibleStartTime)) *
        calendarParameters.heightOfDayTimeframesDiv) /
        calendarParameters.visibleStartToEnd;
  }

  applyEventDivDataForDiv(entryDiv) {
    entryDiv.style.left = `${this.xOfEventDiv}px`;
    entryDiv.style.width = `${this.widthOfEventDiv}px`;
    entryDiv.style.height = `${this.heightOfEventDiv}px`;
    entryDiv.style.top = `${this.yOfEventDiv}px`;
  }
}
